import i18n  from '@/lang';

export default [
  {
    path: '/representation',
    name: i18n.t('RouterName.表现') as string,
    component: () => import(/* webpackChunkName: "representation" */ '@/views/representation/index.vue')
  },
  {
    path: '/representation/chooseGroup',
    name: '选择分组批次',
    component: () => import(/*webpackChunkName: "representation_chooseGroup" */ '@/views/representation/chooseGroup/chooseGroup.vue')
  },
  {
    path: '/representation/performanceStatistics',
    name: '表现统计',
    component: () => import(/*webpackChunkName: "representation_performanceStatistics" */ '@/views/representation/performanceStatistics/performanceStatistics.vue')
  },
  {
    path: '/representation/studetail',
    name: '表现详情',
    component: () => import(/*webpackChunkName: "representation_studetail" */ '@/views/representation/studetail/studetail.vue')
  },
  {
    path: '/representation/starlog',
    name: '表现奖励',
    component: () => import(/*webpackChunkName: "representation_studetail" */ '@/views/representation/starlog/starlog.vue')
  },
  {
    path: '/representation/scan',
    name: '扫描星星卡',
    component: () => import(/*webpackChunkName: "representation_studetail" */ '@/views/representation/scan/scan.vue')
  },
  // 学生端表现首页
  {
    path: '/representation/stuRepresentaionIndex',
    name: i18n.t('RouterName.我的表现') as string,
    component: () => import(/*webpackChunkName: "representation_studetail" */ '@/views/representation/stuRepresentaionIndex/stuRepresentaionIndex.vue')
  }
];
